import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageTilemap } from '../voyageTilemap-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageSystemCreate {
  systemId: number
  key: string
  i: number
  j: number
}

export const voyageMessageId = EVoyageMessage.SystemCreate

export function write(m: IMessageWriter, d: IMessageSystemCreate) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.systemId)
  messageWriter.write16(m, d.i)
  messageWriter.write16(m, d.j)
  messageWriter.writeString(m, d.key)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageSystemCreate = {
    systemId: messageWriter.read32(m),
    i: messageWriter.read16(m),
    j: messageWriter.read16(m),
    key: messageWriter.readString(m),
  }

  return d
}

export function test() {
  let ex: IMessageSystemCreate = {
    systemId: 100,
    key: 'med-123',
    i: 7,
    j: 8,
  }
  messageWriter.test('system-create', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  voyageTilemap.networkAddSystem(msg)
}

export function sendMessageAndImmediatelyExecute(msg: IMessageSystemCreate) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
